import { trpc } from '../lib/api';
import { App } from 'antd';
import { getErrorMessage } from '../utils/errorMessage';

/**
 * ストレージ容量情報を取得
 */
export function useStorageCapacity() {
  return trpc.storage.getCapacity.useQuery(undefined, {
    refetchInterval: 60000, // 1分ごとに更新
    staleTime: 30000, // 30秒はキャッシュを使用
  });
}

/**
 * ストレージ追加オプションの操作
 */
export function useStorageAddons() {
  const { message } = App.useApp();
  const utils = trpc.useContext();

  const purchaseAddon = trpc.storage.purchaseAddon.useMutation({
    onSuccess: (result) => {
      utils.storage.getCapacity.invalidate();
      message.success(`追加オプションを購入しました: +${result.addon.totalCapacityGB}GB`);
    },
    onError: (error: unknown) => {
      message.error(`購入に失敗しました: ${getErrorMessage(error, '詳細不明')}`);
    },
  });

  return {
    purchaseAddon,
    isPurchasing: purchaseAddon.isPending,
  };
}

/**
 * 容量チェック
 */
export function useCapacityCheck(fileSize: number) {
  return trpc.storage.checkCapacity.useQuery(
    { fileSize },
    { enabled: fileSize > 0 }
  );
}
